import type { Companion } from '@/types/admin';
import { Users } from 'lucide-react';

interface CompanionsListProps {
  companions: Companion[];
  onCompanionClick?: (userId: string) => void;
}

/**
 * CompanionsList - List of users who shared the order
 */
export function CompanionsList({ companions, onCompanionClick }: CompanionsListProps) {
  if (companions.length === 0) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Users className="h-4 w-4" />
        <span>Sin acompañantes</span>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
        <Users className="h-4 w-4" />
        <span>Acompañantes ({companions.length})</span>
      </div>
      <ul className="space-y-1">
        {companions.map((companion) => (
          <li key={companion.id}>
            {onCompanionClick ? (
              <button
                onClick={() => onCompanionClick(companion.id)}
                className="text-sm text-blue-600 hover:text-blue-700 hover:underline"
              >
                {companion.name || companion.email}
              </button>
            ) : (
              <span className="text-sm text-gray-700">
                {companion.name || companion.email}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
